var map = {
	"./desktop/desktopTemplate": [
		52117,
		620,
		6521,
		7426,
		2117
	],
	"./mobile/mobileTemplate": [
		69539
	],
	"./tablet/tabletTemplate": [
		54538,
		6521,
		7426,
		4538
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 38872;
module.exports = webpackAsyncContext;